import PlanningActual from './PlanningActual.type';

const initialState = {
  planningActualReducer: {},
  yearsCompareReducer: {},
};

const PlanningActualReducer = (state = initialState, action) => {
  switch (action.type) {
    case PlanningActual.CATEGORY2:
      return {
        ...state,
        planningActualReducer: action.payload,
      };
    case PlanningActual.RESET:
      return {
        ...state,
        category2: [],
      };
    case PlanningActual.YEARSDATA:
      return {
        ...state,
        yearsCompareReducer: action.payload,
      };

    default:
      return state;
  }
};

export default PlanningActualReducer;
